export default function formatDate(
  date: string,
  options?: { displayDay?: boolean }
) {
  let safariFriendly = date;
  // Orderdesk date starts with date formatted ass YYYY-MM-DD, safari does not like that
  if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}/.test(date)) {
    safariFriendly = date.replace(/-/g, "/");
  }

  return new Date(safariFriendly).toLocaleDateString(
    "en-US", // Use english language
    options?.displayDay // Format date
      ? {
          month: "short",
          day: "numeric",
          year: "numeric",
        }
      : {
          month: "short",
          year: "numeric",
        }
  );
}
